import moment from 'moment'
import { sortBy } from 'lodash'

export const global = {
  data () {
    return {
      isMobileSize: false,
      captureStatus: [
        // 0: 未請款, 1: 已請款, 2: 請款成功, 9: 請款失敗
        {title: this.$t('portal.reports.captureStatus.positive0'), value: '+0'},
        {title: this.$t('portal.reports.captureStatus.positive1'), value: '+1'},
        {title: this.$t('portal.reports.captureStatus.positive2'), value: '+2'},
        {title: this.$t('portal.reports.captureStatus.positive9'), value: '+9'},
        {title: this.$t('portal.reports.captureStatus.negative0'), value: '-0'},
        {title: this.$t('portal.reports.captureStatus.negative1'), value: '-1'},
        {title: this.$t('portal.reports.captureStatus.negative2'), value: '-2'},
        {title: this.$t('portal.reports.captureStatus.negative9'), value: '-9'}
      ],
      captureStatusNormal: [
        // 0: 未請款, 1: 已請款, 2: 請款成功, 9: 請款失敗
        {text: this.$t('portal.reports.captureStatus.normal0'), value: '0'},
        {text: this.$t('portal.reports.captureStatus.normal1'), value: '1'},
        {text: this.$t('portal.reports.captureStatus.normal2'), value: '2'},
        {text: this.$t('portal.reports.captureStatus.normal9'), value: '9'}
      ],
      tradeType: [
        {text: '實體', value: 1},
        {text: '網路', value: 2},
        {text: '實體 & 網路', value: 3}
      ],
      notifiCategoryBtns: [
        {text: '全部', value: 'all'},
        {text: '公告', value: 'ANNOUNCEMENT', color: 'achYellow'},
        {text: '維護', value: 'MAINTENANCE', color: 'achRed white--text'},
        {text: '會員', value: 'MEMBER', color: 'achGreen white--text'}
      ],
      companyPhone: '02-2267-5557'
    }
  },
  mounted () {
    this.isMobileSize = this.$vuetify.breakpoint.xsOnly
  },
  computed: {
    devMode () {
      return process.env.NODE_ENV !== 'production'
    },
    payments () {
      return sortBy(this.$store.getters.getStoresAllPayments.map(item => {
        item.title = this.$i18n && ((item.name.indexOf('inst_') >= 0)
          ? this.$t('portal.payments.inst_', {msg: parseInt(item.name.split('_')[1])})
          : this.$t('portal.payments.' + item.name))
        item.selected = true
        return item
      }), [val => val.title])
    },
    isMultiStore () {
      return this.$store.getters.getStoreList.length > 1
    },
    storeInfo () {
      let storeInfo = this.$store.getters.getStoresInfo
      let userInfo = this.$store.getters.getUserInfo
      return {
        store: storeInfo,
        user: userInfo
      }
    },
    groupInfo(){
      let grouplist = this.$store.getters.getGroupsList.brand
      console.log("set group name list " + JSON.stringify(grouplist))
      if(grouplist == undefined){
        return ""
      }
      let isBrandOwner = grouplist.isOwner
            let brand = grouplist
            let regions = []
            let stores = []
            let i = 0
            if(isBrandOwner){
              return brand.name
            }else{
                regions = brand.regions
                for(i = 0; i < regions.length; i++){
                   if(regions[i].isOwner){
                    return  regions[i].name   
                   }else{
                       stores = regions[i].stores
                       for(i = 0; i < stores.length; i++){
                          if(stores[i].isOwner){
                            return  stores[i].name
                          }
                       }
                   }
                }
            }
    },
    allNotifications () {
      return this.$store.getters.getNotifications.map(item => {
        let category = this.notifiCategoryBtns.find(type => type.value === item.type)
        return {
          id: item.id,
          type: item.type,
          category: category.text,
          title: item.title,
          content: item.content,
          color: category.color,
          read: item.read,
          createTime: this.dateFormat(moment(item.createTime, moment.HTML5_FMT.DATETIME_LOCAL_SECONDS).format('YYYY-MM-DD (dd)')),
          rawCreateTime: item.createTime
        }
      }).sort((a, b) => { return b.id - a.id })
    },
    isMobileMode () {
      return this.$vuetify.breakpoint.smAndDown
    },
    brandLogo () {
      let img = this.$store.getters.getUserInfo.userImgPath
      return img || require('@/assets/img/bg_userlogo.svg')
    },
    getGroupName(){
      let undefine = "未分區";
      let group = this.$store.getters.getGroupsList;
      if (group.length == 0) {
        return [];
      } else {
        let regionList = group.brand.regions;
        let groupName = regionList.map(function(selectOption) {
          if (selectOption.id != "" && selectOption.id != null ) {
            return selectOption.name;
          } else {
            return undefine;
          }
        });
        if (groupName.length > 1) {
          groupName.push("所有店區");
        }
        this.selectedgroup = groupName[groupName.length - 1]
        return groupName;
      }
    },
    getStoreName(){
      let name = [];
      let group = this.$store.getters.getGroupsList;
      if (group.length == 0) {
        return [];
      } else {
        let regionList = group.brand.regions;
        if (this.selectedgroup === "所有店區") {
          name.push("");
        } else if (this.selectedgroup === "未分區") {
          name = regionList.filter(selectOption => selectOption.id === "" || selectOption.id === null);
        } else if (this.selectedgroup != "未分區" && this.selectedgroup != "所有店區" && this.selectedgroup != "") {
          name = regionList.filter(selectOption => selectOption.name === this.selectedgroup);
        } else {
          name = regionList.filter(selectOption => selectOption.id != "" && selectOption.name == "");
        }
        console.log("getstorename object " + JSON.stringify(name[0]));
        if (name[0] != null && name[0].stores != null && name[0].stores.length > 0) {
          let storeName = name[0].stores.map(store => store.name);
          if (storeName.length > 1) {
            storeName.push("所有分店");
          }
          this.selectedstore = storeName[storeName.length - 1]
          return storeName;
        } else if (name[0] == "") {
          this.selectedstore = "所有分店"
          return ["所有分店"];
        } else {
          this.selectedstore = "此區無分店"
          return ["此區無分店"];
        }
      }
    },getAllStoreName(){
      let name = [];
      let group = this.$store.getters.getGroupsList;
      if (group.length == 0) {
        return [];
      } else {
        let regionList = group.brand.regions;
        if (this.selectedgroup === "所有店區") {
          name.push("");
        } else if (this.selectedgroup === "未分區") {
          name = regionList.filter(selectOption => selectOption.id === "" || selectOption.id === null);
        } else if (this.selectedgroup != "未分區" && this.selectedgroup != "所有店區" && this.selectedgroup != "") {
          name = regionList.filter(selectOption => selectOption.name === this.selectedgroup);
        } else {
          name = regionList.filter(selectOption => selectOption.id != "" && selectOption.name == "");
        }
        console.log("getstorename object " + JSON.stringify(name[0]));
        if (name[0] != null && name[0].stores != null && name[0].stores.length > 0) {
          let storeName = name[0].stores.map(store => store.name);
          this.selectedstore = storeName[storeName.length - 1]
          return storeName;
        } else if (name[0] == "") {
          this.selectedstore = "所有分店"
          return ["所有分店"];
        } else {
          this.selectedstore = "此區無分店"
          return ["此區無分店"];
        }
      }
    }
    





  },
  methods: {
    dateFormat (dateString) {
      return dateString.replace(/-/g, '/')
    },
    numberFormat (num) {
      return num && num.toLocaleString()
    },
    priceFormat (num) {
      return (num < 0) ? '-$' + this.numberFormat(Math.abs(num)) : '$' + this.numberFormat(num)
    },
    getPayment (type) {
      return (type && this.payments.length !== 0 && this.payments.find(item => item.value === type)) && this.payments.find(item => item.value === type).title
    },
    getCaptureStatus (status) {
      return (status && this.captureStatus.find(item => item.value === status)) && this.captureStatus.find(item => item.value === status).title
    },
   
    getWeekString (date) {
      return this.dateFormat(moment(date.replace(/\//g, '-')).format('YYYY-MM-DD (dd)'))
    },
    getTimestampToDate (timestamp) {
      return moment(timestamp).format('YYYY-MM-DD')
    },
    getErrorCodeMsg (code) {
      if (this.$t(code)) return this.$t(code)
    },
    getCurrentStoreId(){
      let _self = this
      let group = this.$store.getters.getGroupsList
      console.log("getCurrentStoreId group " + JSON.stringify(group) )
      let storeIds = []
      if (group.length != 0) {
        let regionList = group.brand.regions;
        if(_self.selectedgroup == "未分區"){
          regionList.forEach(function(selectOption) {
                if (selectOption.name == "" && (selectOption.id == "" || selectOption.id == null )) {
                  selectOption.stores.forEach(function(store) {
                    if (store.name === _self.selectedstore || _self.selectedstore === "所有分店" ) {
                      storeIds.push(store.id)
                    }
                  });         
                }
              });
        }else if(_self.selectedgroup == ""){
          regionList.forEach(function(selectOption) {
                if (selectOption.name == "" && selectOption.id !== "") {
                  selectOption.stores.forEach(function(store) {
                    if (store.name === _self.selectedstore || _self.selectedstore === "所有分店" ) {
                      storeIds.push(store.id)
                    }
                  });         
                }
              });
        }else{
          regionList.forEach(function(selectOption) {
                if (selectOption.name === _self.selectedgroup) {
                  selectOption.stores.forEach(function(store) {
                    if (store.name === _self.selectedstore || _self.selectedstore === "所有分店") {
                      storeIds.push(store.id)
                    }
                  });         
                }
              });
        }
      }
      console.log("getCurrentStoreId storeId "+ storeIds)
      return storeIds
    },
    // 處理 表格內 資料格式
    $__tableDataFormat (item, header, prefix = ' - ') {
      let result = prefix
      if (item) {
        switch (header.unit) {
          case 'price':
            result = this.priceFormat(item)
            break
          case 'number':
            result = this.numberFormat(item)
            break
          default:
            result = item
            break
        }
      }
      return result
    },
    $__checkTimestamp (timestamp) {
      // N 秒後才進行下一次 fetch
      return (moment().unix() - timestamp) >= 30
    },
    $__getStoresAllPayments (payments) {
      let colors = [
        '#e2dacf',
        '#ffe800',
        '#71c6c1',
        '#5482ab',
        '#6e2585',
        '#bd1d65',
        '#e1306c',
        '#cc0000',
        '#123962'
      ]
      let counter = 0
      // "installment"
      // "point"
      let result = []
      payments.forEach(item => {
        let obj = {}
        obj.name = item
        obj.title = this.$i18n && ((item.indexOf('inst_') >= 0)
          ? this.$t('portal.payments.inst_', {msg: parseInt(item.split('_')[1])})
          : this.$t('portal.payments.' + item))
        obj.selected = true
        switch (item) {
          case 'applepay':
            obj.color = '#59585a'
            break
          case 'linepay':
            obj.color = '#97c464'
            break
          case 'samsungpay':
            obj.color = '#235c97'
            break
          case 'credit':
            obj.color = '#fed53a'
            break
          case 'googlepay':
            obj.color = '#c5d340'
            break
          case 'piapp':
            obj.color = '#1aadc7'
            break
          case 'ipass':
            obj.color = '#e4690e'
            break
          case 'easycard':
            obj.color = '#089082'
            break
          default:
            obj.color = colors[counter]
            counter++
            break
        }
        result.push(obj)
      })
      return sortBy(result, [val => val.title])
    },
    doLogout () {
      this.$store.dispatch('cleanLoginInfo')
      let auth2 = gapi.auth2.getAuthInstance();
      auth2.signOut().then(function () {
       console.log('User signed out.');
       });
      this.$router.push('/login')
    }
  },
  watch: {
    '$vuetify.breakpoint.xsOnly' (value) {
      this.isMobileSize = value
    }
  }
}
